<template>
    <div class="flex items-center dark:text-grey-800 text-14" v-if="paymentMethod != null">
        <div
            class="w-[33px] h-6 items-center flex justify-center px-0.5 pr-1"
            :class="{
                'border border-grey-500': !table,
            }"
        >
            <component
                :is="$icon.name(paymentMethod.brand)"
                class="w-full"
                :class="{
                    'stroke-black fill-black dark:stroke-white dark:fill-white': paymentMethod.brand != 'mastercard',
                    'opacity-10': disabled,
                }"
            />
        </div>

        <p class="px-2 -mt-0.5">••••</p>
        <p class="pr-2">{{ paymentMethod.last_4 }}</p>
        <p
            :class="{
                '': !table,
            }"
        >
            {{ paymentMethod.exp_month <= 9 ? '0' : '' }}{{ paymentMethod.exp_month }}/{{ String(paymentMethod.exp_year).slice(2, 4) }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        paymentMethod: Object,
        table: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
